import { Fragment, useState } from 'react';
import CyoElement from './CyoElement';
import {
  OCCASIONS,
  OCCASIONS_SORT_ORDER,
  OCCASIONS_CUSTOMIZE_FILTER,
  OCCASION_TO_EDIT_DELIVERY_HACK,
  NONMEAL_OCCASIONS,
} from '../constants/constants';
import { PAGES } from '../constants/order_details';
import { featuredPath, groceriesPath } from '../customize/const';
import {
  ProductCard,
  ProductCardStyleVariant,
} from '@hungryroot/components-product-card';
import {
  AddMore,
  StyleVariant as AddMoreVariant,
} from '../../../../components/AddMore/AddMore';
import { IconVariant } from '@hungryroot/icons';
import { FavoritableModifiedIngredientsRdpModal } from '../../../../components/RDP/Modal/FavoritableModifiedIngredientsRdpModal';
import {
  SaveRecipes,
  Variant as SaveRecipesVariant,
} from '../../../../components/SaveRecipes/SaveRecipes';
import styles from './MealPlans.module.css';

export const MealPlans = ({
  customer,
  pairings,
  occasions,
  orderId,
  togglePdpModal,
  page,
  customerCyo,
  toggleCyoModal,
}) => {
  if (!pairings || !occasions) return null;

  const [modalPairing, setModalPairing] = useState(null);

  const toggleCyoModalAndTracking = () => {
    toggleCyoModal();
    dataLayer.push({ event: `hr.cyo_modal_open.${page}#meal_plans` });
  };

  let osa = [...OCCASIONS_SORT_ORDER];
  const swapAndFilterOcccasions = () => {
    let explorer = 0;
    let anchor = 0;
    for (let i = 0; i < osa.length; i++) {
      if (occasions[parseInt(osa[i])]) {
        let tmp = osa[anchor];
        osa[anchor] = osa[explorer];
        osa[explorer] = tmp;
        anchor++;
      }
      explorer++;
    }
    osa = osa.filter((ele) => NONMEAL_OCCASIONS.includes(parseInt(ele)));
    osa = !occasions[0] ? osa.slice(0, osa.length - 1) : osa;
  };

  let numOfPairings = pairings.length;
  let isUpcoming = page === PAGES.upcoming;
  isUpcoming ? swapAndFilterOcccasions() : null;

  let isDelivered = page === PAGES.delivered;

  let getPairing = (pairing) => {
    return (
      <ProductCard
        isRecipe={true}
        testid={`pairing-card-${pairing.name}`}
        styleVariant={ProductCardStyleVariant.Medium}
        featuredImage={{
          src: pairing.featured_img,
          alt: pairing.name,
        }}
        title={`${pairing.name} ${pairing.is_modified ? ' (edited)' : ''}`}
        details={[
          {
            icon: IconVariant.ClockIllustrated,
            text: `${pairing.cooking_time} min.`,
          },
          {
            icon: IconVariant.Calories,
            text: `${pairing.calories} cal.`,
          },
          {
            icon: IconVariant.Person,
            text: `${pairing.servings} serv.`,
          },
        ]}
        onClick={() =>
          setModalPairing({
            pairing: pairing,
            initialIngredientIds:
              pairing.order_details &&
              pairing.order_details.map(({ product }) => product),
          })
        }
        favoriteAction={
          customer?.id && (
            <SaveRecipes
              variant={SaveRecipesVariant.Card}
              pairingId={pairing.id}
              pairingName={pairing.name}
              customer={customer}
              testid={`product-card-save-${pairing.id}`}
            />
          )
        }
        binaryRatings={
          isDelivered && customer?.id
            ? {
                pairingData: pairing,
                orderId: orderId,
                customerId: customer.id,
                pathForTracking: 'delivered',
              }
            : undefined
        }
        ingredients={pairing.ingredients}
      />
    );
  };

  // Show Featured pairings first, so sort them with this function:
  let orderedPairings = (pairings) => {
    let featuredPairings = [];
    let normalPairings = [];
    for (let p of pairings) {
      if (p.is_featured) {
        featuredPairings.push(p);
      } else {
        normalPairings.push(p);
      }
    }
    return featuredPairings.concat(normalPairings);
  };

  return (
    <div className="meal-plans">
      <div
        className="hr-mb-16 flex-container"
        data-testid="lunch-dinner-section"
      >
        <span className="hr-demi hr-title-sm">Lunch + Dinner</span>
        <span className="recipes-num">
          &nbsp;({`${numOfPairings} recipe${numOfPairings === 1 ? '' : 's'}`})
        </span>
      </div>
      {pairings.length < 1 && isUpcoming ? (
        <div className="no-pairings-msg hr-mb-32">
          It looks like you have no recipes in your delivery this week.{' '}
          <br className={styles['hr-desktop']} />
          You can always add some by <a href={featuredPath}>editing</a> your
          delivery.
        </div>
      ) : null}
      {pairings.length < 1 && !isUpcoming ? (
        <div className="no-pairings-msg hr-mb-32">
          Since you got all standalone items, there are no recipes in your
          delivery this week.
          <br className={styles['hr-desktop']} /> Looking for ideas or
          inspiration? You can search all of our recipes by ingredient, name, or
          type <a href="/recipes/">here</a>.
        </div>
      ) : null}
      <div className="pairings-container">
        {orderedPairings(pairings).map((pairing, idx) => {
          return (
            <div key={pairing.id + idx} className="hr-mb-32 pairing-card">
              {getPairing(pairing)}
            </div>
          );
        })}
      </div>
      {osa.map((id) => {
        let redirectStr = '';
        if (OCCASION_TO_EDIT_DELIVERY_HACK[id]) {
          redirectStr = `${groceriesPath}?${OCCASION_TO_EDIT_DELIVERY_HACK[id]}`;
        } else {
          redirectStr = `${groceriesPath}?${OCCASIONS_CUSTOMIZE_FILTER[
            id
          ].toLowerCase()}=1`;
        }
        if (!occasions[id] && !isUpcoming) return null;

        return (
          <Fragment key={id}>
            <div className="occasions-title flex-container">
              <span className="hr-demi hr-title-sm hr-mb-16">
                {OCCASIONS[id]}
              </span>
              &nbsp;
            </div>
            <div
              className="products-list-container"
              data-testid={`${OCCASIONS[id]}-container`}
            >
              {occasions[id] &&
                occasions[id].map((product, idx) => {
                  return (
                    <div
                      key={product.id + idx}
                      className="hr-mb-32 product-wrapper"
                      data-testid="product-card-wrapper"
                    >
                      {/* this component uses the product card, but the underlying API will not be updated
                      to contain the badges property https://docs.google.com/document/d/11zq2fe7OmdljNPxDwCw2e4oZxP-t_TXhxRTMo-N7HMQ/edit#heading=h.ut7vevev5unc
                      the API called is from app/frontend/react/src/api/api.js `getOrder` */}
                      <ProductCard
                        isRecipe={false}
                        testid={`product-card-${product.name}`}
                        styleVariant={ProductCardStyleVariant.Small}
                        featuredImage={{
                          src: product.card_image_url,
                          alt: product.name,
                        }}
                        title={product.name}
                        onClick={() => togglePdpModal(product)}
                        label={{
                          text: product.brand_name,
                        }}
                      />
                    </div>
                  );
                })}
              {isUpcoming ? (
                <AddMore
                  styleVariant={AddMoreVariant.Small}
                  url={redirectStr}
                  testid="add-more"
                />
              ) : null}
            </div>
          </Fragment>
        );
      })}
      {isUpcoming && customerCyo ? (
        <Fragment>
          <CyoElement
            isProductCard={true}
            customerCyo={customerCyo}
            togglePdpModal={togglePdpModal}
          />
          <div
            className="hr-subtitle-md other-options-link"
            onClick={() => toggleCyoModalAndTracking()}
          >
            {'See other options'}
            <span className="icon"></span>
          </div>
        </Fragment>
      ) : null}
      {isUpcoming ? (
        <div className={`${styles['hr-desktop']} hr-align-center hr-ptb-32`}>
          <a href={featuredPath}>
            <div className="hr-btn-blue hr-wide">Edit Delivery</div>
          </a>
        </div>
      ) : null}
      {modalPairing !== null && (
        <FavoritableModifiedIngredientsRdpModal
          onDismiss={() => setModalPairing(null)}
          modifiedIngredientIds={modalPairing.initialIngredientIds}
          pairing={modalPairing.pairing}
        />
      )}
    </div>
  );
};

export default MealPlans;
